import React, { useState, useEffect, useRef } from 'react'
import '../CoursePage/CoursePage.css'
import Curriculum from "../Curriculum/Curriculum.jsx";
import sjrleftgirl from "../../assets/sjrleftgirl.jpg";
import jrrightgirl from "../../assets/sjrrightgirl.jpg";
import dafoundational from "../../assets/dahfoundational.jpeg";
import dah1foundational from "../../assets/dah1foundational.jpg"
import daintermediate from "../../assets/dahintermediate.png";
import dah1intermediate from "../../assets/dah1intermediate.png"
import daadvanced from "../../assets/dahadvanced.jpeg";
import dah1advanced from "../../assets/dah1advanced.jpeg";
import cloudzest from '../../assets/cloudzest.jpg'
import virtusa from '../../assets/Virtusa.png'
import cognizant from '../../assets/cognizant.png'
import lancesoft from '../../assets/Lancesoft.png'
import accenture from '../../assets/Accenture.png'
import techmahindra from '../../assets/TMlogo.png'
import trigent from '../../assets/trigent.png'
import info from '../../assets/info.jpg'
import lti from '../../assets/lti.png'
import prodapt from '../../assets/prodapt.png'
import straive from '../../assets/straive.jpg'
import concentrix from '../../assets/Concentrix.png'
import nttdata from '../../assets/ntt data.png'
import walkingtree from '../../assets/walkingtree.png'
import globallogic from '../../assets/globallogic.png'
import blueyonder from '../../assets/blueyonder.png'
import deloitte from '../../assets/deloitte.png'
import covalense from '../../assets/covalense.jpg'
import statusneo from '../../assets/statusneo.jpg'

import Amazon from "../../assets/logos/Amazon Logo.webp";
import capgemini from "../../assets/logos/Capgemini Logo.webp";
import HSBC from "../../assets/logos/HSBC Logo.webp"
import lowes from "../../assets/logos/Lowes logo.webp";
import Maersk from "../../assets/logos/Maersk Logo.webp";
import Make from "../../assets/logos/MakeMyTrip Logo.webp";
import Optum from "../../assets/logos/Optum Logo.webp";
import tata from "../../assets/logos/Tata Digital Logo.webp";
import thoughtworks from "../../assets/logos/Thoughtworks Logo.webp";
import visa from "../../assets/logos/VISA Logo.webp";
import hirecompanylogo from "../../assets/hirecompanylogo1.png";
import mentorcompany from '../../assets/mentorcompany.png';
import trusted from "../../assets/WebsitePlacement.png";

import mentorimage from '../../assets/mentorimage.png';
import mentorimage2 from '../../assets/mentorimage2.png';
import mentorimage3 from '../../assets/mentorimage3.png';
import mentorimage4 from '../../assets/mentorimage4.png';
import mentorimage5 from '../../assets/mentorimage5.png';
import mentorimage6 from '../../assets/mentorimage6.png';
import mentorimage8 from '../../assets/mentorimage8.png';
import mentorimage9 from '../../assets/mentorimage9.png';
import mentorimage10 from '../../assets/mentorimage10.jpeg';
import mentorimage11 from '../../assets/mentorimage11.png';
import mentorimage12 from '../../assets/mentorimage12.png';
import mentorimage13 from '../../assets/mentorimage13.png';
import mentorimage14 from '../../assets/mentorimage14.png';
import mentorimage15 from '../../assets/mentorimage15.JPG';
import mentorimage16 from '../../assets/mentorimage16.png';
import mentorimage17 from '../../assets/mentorimage17.png';
// import mentorimage18 from '../../assets/mentorimage18.jpeg';
import mentorimage19 from '../../assets/mentorimage19.png';
import mentorimage20 from '../../assets/mentorimage20.png';
import mentorimage21 from '../../assets/mentorimage21.png';
import mentorimage22 from '../../assets/mentorimage22.png';
import mentorimage23 from '../../assets/mentorimage23.png';
import mentorimage24 from '../../assets/mentorimage24.png';
import mentorimage25 from '../../assets/mentorimage25.png';
import mentorimage26 from '../../assets/mentorimage26.png';
import mentorimage27 from '../../assets/mentorimage27.png';
import mentorimage28 from '../../assets/mentorimage28.png';
import certificate from '../../assets/certificatecourse.png';
import ibmcertificate from '../../assets/certificateportion2.png';
import microsoftcertificate from '../../assets/certificateportion1.png';
// import certificate from '../../assets/certificatecourse.png'
import bessential from "../../assets/bootcampessential.png";
import bplus from "../../assets/bootcampplus.png";
import bpro from "../../assets/bootcamppro.png";

import dsjupyter from "../../assets/dsjupyter.jpeg";
import dsnumpy from "../../assets/dsnumpy.png";
import dspanda from "../../assets/dspanda.png";
import dsazure from "../../assets/dsazure.png";
import dsmatplotlib from "../../assets/dsmatplotlib.png";
import dsseaborn from "../../assets/dsseaborn.jpeg";

import boexcel from '../../assets/boexcel.jpg';
import bosql from '../../assets/bosql.png';
import bopowerbi from'../../assets/bopowerbi.jpg';
import botableau from '../../assets/botableau.jpg';
import bonumpypanda from '../../assets/bonumpypanda.png';
import bobusinessstatistics from '../../assets/bobusinessstatistics.jpg';
import bopython from '../../assets/bopython.jpg';
import boaws from '../../assets/boaws.png';
import bobigdata from '../../assets/bobigdata.png';
import { FaUsersLine } from "react-icons/fa6";
import { LuSendHorizontal } from "react-icons/lu";
import { Bar } from 'react-chartjs-2';
import { FaSackDollar } from "react-icons/fa6";
import $ from 'jquery';
import { FaArrowRight } from 'react-icons/fa'; 
import gifone from '../../assets/gifone.png';
import giftwo from '../../assets/giftwo.png';
import gifthree from '../../assets/gifthree.png';
import giffour from '../../assets/giffour.png';
import upskill from "../../assets/upskill.svg";
import { FaBriefcase } from "react-icons/fa";
import cintelli from "../../assets/cintellij.png";
import cgithub from "../../assets/cgithub.png";
import cjunit from "../../assets/cjunit.png"
import cjava from "../../assets/cjava.png"
import cbullettick from "../../assets/corangetick.png"
import certificateportion1 from '../../assets/certificateportion1.png'
import certificateportion2 from '../../assets/certificateportion2.png'
import certificateportion3 from '../../assets/certificateportion3.png'
import { FaCheckCircle } from "react-icons/fa";

import dsexcel from "../../assets/dsexcel.png";
import dsetl from "../../assets/dsetl.jpeg";
import dsbusiness from "../../assets/dsbusiness.png";
import dspython from "../../assets/dspython.jpeg";
import dsmicrosoft from "../../assets/dsmicrosoft.png";
import dsai from "../../assets/dsai.jpeg";
import dscapstone from "../../assets/dscapstone.png";

import CanvasJSReact from '@canvasjs/react-charts';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);



var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const DataScience = () => {

  const [activeTab, setActiveTab] = useState('IBM');

  const steps = [
    { img: gifone, title: 'Upskill Now', description: 'Live sessions, expert 1:1 doubt clearing, and quizzes.' },
    { img: giftwo, title: 'Capstone Projects', description: 'Work with industry experts on practical projects.' },
    { img: gifthree, title: 'Boost Profile', description: 'Mock interviews and resume-building sessions.' },
    { img: giffour, title: 'Career Goals', description: 'Get placement assistance with top companies.' }
  ];

  useEffect(() => {
    $(window).on('scroll', function () {
      $('.journey-container').each(function () {
        const top = $(this).offset().top;
        const windowTop = $(window).scrollTop();
        const windowHeight = $(window).height();

        if (windowTop + windowHeight > top + 100) {
          $(this).addClass('animate');
        } else {
          $(this).removeClass('animate');
        }
      });
    });

    return () => $(window).off('scroll');
  }, []);

  const certifications = {
    IBM: {
      title: 'Course Completion Certificate from IBM',
      points: [
        'Complete your training with the internationally recognized certificate.',
        'Validate your Data Science skills with IBM Course Completion Certificate.',
        'Get acknowledged in IT sector by adding IBM Certificate to your profile.'
      ],
      img: ibmcertificate
    },
    Microsoft: {
      title: 'Course Completion Certificate from Microsoft',
      points: [
        'Complete your training with Microsoft Certification.',
        'Validate your skills with Microsoft Course Completion Certificate.',
        'Showcase your expertise with globally recognized certificates.'
      ],
      img: microsoftcertificate
    },
    'Project Certificate': {
      title: 'Project Completion Certificate',
      points: [
        'Successfully complete your capstone projects.',
        'Work with industry-standard tools and technologies.',
        'Showcase your hands-on project experience.'
      ],
      img: certificate
    }
  };



  const statsData = [
    { number: 120, text: "Live Hours" },
    { number: 40, text: "Tools" },
    { number: 20, text: "Projects" },
    { number: 50, text: "Assessments" },
    { number: 250, text: "Mentorship Hours" },
  ];

  const [counts, setCounts] = useState(statsData.map(() => 0));


  const data = {
    labels: ['0-1 yrs', '1-4 yrs', '5-9 yrs', '10-14 yrs'],
    datasets: [
      {
        label: 'Salary (LPA)',
        data: [5, 8, 14, 24],
        backgroundColor: '#FF4C4C',
        borderRadius: 5,
        borderSkipped: false,
        barThickness: 80,
        categoryPercentage: 1, // Reducing space between bars
        barPercentage: 1, // Adjusting bar width ratio within category
      },
    ],
  };

  const option = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: '#1c0606',
        },
      },
      title: {
        display: true,
        text: 'Salary Growth Over Experience',
        color: '#1c0606',
        font: {
          size: 20,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          color: '#1c0606',
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.1)',
          drawBorder: false, // Remove the Y-axis border line
          lineWidth: 2,
          display: true,
        },
      },
      x: {
        ticks: {
          color: '#1c0606',
        },
        grid: {
          display: false,
        },
      },
    },
    animation: {
      duration: 1500,
      easing: 'easeOutBounce',
    },
  };

  useEffect(() => {
    const intervals = statsData.map((stat, index) => {
      return setInterval(() => {
        setCounts((prevCounts) => {
          const newCounts = [...prevCounts];
          if (newCounts[index] < stat.number) {
            newCounts[index] += 1; // Increase by 1 per interval
          } else {
            clearInterval(intervals[index]); // Stop when target reached
          }
          return newCounts;
        });
      }, 80); // Adjust speed for smoother animation
    });

    return () => intervals.forEach(clearInterval); // Cleanup on unmount
  }, []);


  const curriculumRef = useRef(null); // Create a reference

  // Function to scroll to the Curriculum component
  const handleScrollToCurriculum = () => {
    if (curriculumRef.current) {
      curriculumRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const Card = ({ image, title, description }) => (
    <div className="Handonexperience-card">
      <img src={image} alt={title} className="Handonexperience-card-image" />
      <h2 className="Handonexperience-card-title">{title}</h2>
      <p className="Handonexperience-card-description">{description}</p>
    </div>
  );

   const companyLogos = [
    cloudzest,
    virtusa,
    cognizant,
    lancesoft,
    accenture,
    techmahindra,
    covalense,
    info,
    capgemini,
    lti,
    deloitte,
    blueyonder,
    concentrix,
    nttdata,
    statusneo
  ];

  const mentors = [
    { name: "Venkata Sai", role: "Full Stack Data Scientist", image: mentorimage, company: cloudzest },
    { name: "Bhargav Lakshman", role: "Machine Learning Engineer", image: mentorimage2, company: capgemini },
    { name: "Burra Jyothi", role: "Data Engineer", image: mentorimage3, company: virtusa },
    { name: "Chinna Ram", role: "Cybersecurity Engineer", image: mentorimage4, company: cognizant },
    { name: "Nagi Reddy", role: "Security Analyst", image: mentorimage5, company: lancesoft },
    { name: "Guguloth Veranna", role: "Security Architect", image: mentorimage6, company: accenture },
    { name: "Jangam Rajasekhar", role: "React.Js Developer", image: mentorimage8, company: techmahindra},
    { name: "Leelachaitanya", role: "Data Analyst", image: mentorimage9, company: trigent },
    { name: "Satyavamsi", role: "Business Intelligence Analyst", image: mentorimage10, company: info },
    { name: "Naresh Kumar", role: "Data Storyteller", image: mentorimage11, company: lti },
    { name: "Gopinadh Reddy", role: "Data Security Analyst", image: mentorimage12, company: prodapt},
    { name: "Mahesh Bathula", role: "Security Data Scientist", image: mentorimage13, company: accenture},
    { name: "Mahesh Nandibattina", role: "React.Js Developer", image: mentorimage14, company: straive },
    { name: "Krishna Reddy", role: "Frontend Developer", image: mentorimage15, company: lti },
    { name: "Pavan Kalyan", role: "Backend Developer", image: mentorimage16, company: lti },
    { name: "Nitta Vinod", role: "Web Application Developer", image: mentorimage17, company: concentrix },
    { name: "Thirupathamma", role: "DevOps Engineer", image: mentorimage19, company: nttdata },
    { name: "Simhachalam", role: "Software Engineer", image: mentorimage20, company: walkingtree },
    { name: "Srevali Pachi pulusu", role: "NLP Engineer", image: mentorimage21, company: globallogic },
    { name: "Vasam Arunkumar", role: "Research Scientist", image: mentorimage22, company: blueyonder },
    { name: "Raja Sekhar", role: "Machine Learning Engineer", image: mentorimage23, company: techmahindra },
    { name: "vijay bhele", role: "AI Engineer", image: mentorimage24, company: accenture },
    { name: "Mekala Anil", role: "Ethical Hacker", image: mentorimage25, company: deloitte },
    { name: "Pooja Joshi", role: "Information Security Specialist", image: mentorimage26, company: concentrix },
    { name: "Naveen kumar", role: "Incident Responder", image: mentorimage27, company: covalense},
    { name: "Akhil", role: "Network Security Engineer", image: mentorimage28, company: statusneo },
  ];

  const carouselRef = useRef(null);

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        if (carouselRef.current.scrollLeft >= carouselRef.current.scrollWidth / 2) {
          // Reset scroll to create infinite loop effect
          carouselRef.current.scrollLeft = 0;
        } else {
          carouselRef.current.scrollLeft += 1; // Adjust for smooth speed
        }
      }
    }, 30); // Adjust speed here

    return () => clearInterval(scrollInterval);
  }, []);

  const Cards = ({ image, title, description }) => (
    <div className="bootcamp-card">
      <img src={image} alt={title} className="bootcamp-card-image" />
      <h2 className="bootcamp-card-title">{title}</h2>
      <p className="bootcamp-card-description">{description}</p>
    </div>
  );

  const [activeTabs, setActiveTabs] = useState(0);

  const tabs = [
    "Entry Criteria",
    "Program Delivery + Expected Outcomes",
    "Payment Details",
    "Interview Opportunity",
  ];

  const faqs = [
    {
      question: "Can I get any special discount for this program?",
      answer:
        "We are offering you this program at competitive rates. Hence, we are not offering any discounts; however, we have a lot of financing options to support you to do this program.",
    },
    {
      question: "What financing options do I have?",
      answer: "",
    },
    {
      question: "Will I receive invoice after payment?",
      answer: "",
    },
    {
      question:
        "If a student doesn’t get placed, will he/she be eligible for a Program fee refund?",
      answer: "",
    },
  ];

  const toggleTab = (index) => {
    setActiveTabs(index);
  };


  const [currentTab, setCurrentTab] = useState("Full Stack Developer");

  // Data for info cards for each tab
  const tabData = {
    "Full Stack Developer": [
      {
        title: "Annual Average Salaries",
        image: "bragraph", // Replace with your actual variable
        companies: [],
        description: "",
      },
      {
        title: "Top Companies",
        companies: [
          "amazonlogo", // Replace with your actual variable names
          "axislogo",
          "accenturelogo",
          "careerlogo",
          "capgeminilogo",
        ],
      },
      {
        title: "Demand",
        image: "demandpie", // Replace with your actual variable
        description: "Surge in job postings between 2020 and 2023",
      },
    ],
    "Team Lead": [
      {
        title: "Leadership Salaries",
        image: "leadershipGraph", // Replace with your actual variable
      },
      {
        title: "Growing Companies",
        companies: [
          "teamLeadLogo1",
          "teamLeadLogo2",
          "teamLeadLogo3",
        ],
      },
      {
        title: "Demand",
        image: "teamDemandGraph", // Replace with your actual variable
        description: "Growth in demand for leadership roles",
      },
    ],
    "Director of Engineering": [
      {
        title: "Director Salaries",
        image: "directorGraph", // Replace with your actual variable
      },
      {
        title: "High-Level Companies",
        companies: [
          "directorLogo1",
          "directorLogo2",
          "directorLogo3",
        ],
      },
      {
        title: "Demand",
        image: "directorDemandGraph", // Replace with your actual variable
        description: "Demand for engineering leadership roles",
      },
    ],
  };

    const [showGraphs, setShowGraphs] = useState(false);
    const [activeTabing, setActiveTabing] = useState("Data Scientist");
  
    useEffect(() => {
      const handleScroll = () => {
        const graphSection = document.querySelector(".gr-ds-graph");
        const graphPosition = graphSection.getBoundingClientRect().top;
        const screenPosition = window.innerHeight / 1.3;
  
        if (graphPosition < screenPosition) {
          setShowGraphs(true);
        }
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
  
    const handleTabClick = (tab) => {
      setActiveTabing(tab);
    };
  
    const options = {
      animationEnabled: true,
      exportEnabled: true,
      theme: "light2",
      title: {
        text: "Annual Average Salaries"
      },
      axisY: {
        includeZero: true
      },
      data: [{
        type: "column",
        indexLabelFontColor: "#5A5757",
        indexLabelPlacement: "outside",
        dataPoints: [
          { label: "Min (5L)", y: 5 },
          { label: "Average (8L)", y: 8 },
          { label: "Max (24L)", y: 24 }
        ]
      }]
    };

    const companyImages = [
      visa,
      thoughtworks,
      tata,
      Optum,
      Make,
      Maersk,
      lowes,
      HSBC,
      capgemini,
      Amazon,
];


const courseData = [
  {
    id: 1,
    name: "MS Excel & Databases",
    title: "Data Handling with Excel and Databases",
    description: "Develop essential data handling and querying skills using MS Excel, Advanced Excel features, MS SQL, and NoSQL databases. A foundational step for anyone entering data science.",
    topics: [
      "MS Excel Basics",
      "Advanced Excel Functions",
      "MS SQL for Structured Data",
      "NoSQL for Unstructured Data"
    ],
    image:dsexcel,
    tools: [cintelli, cgithub, cjava]
  },
  {
    id: 2,
    name: "Data Engineering",
    title: "ETL, EDA and Big Data Tools",
    description: "Learn how to extract, transform, and load data (ETL), perform exploratory data analysis (EDA), and utilize platforms like Data Bricks for large-scale data processing.",
    topics: [
      "ETL Pipelines",
      "Exploratory Data Analysis (EDA)",
      "Data Bricks",
      "Azure Data Factory",
      "Data Warehousing Concepts"
    ],
    image:dsetl,
    tools: [cintelli, cgithub, cjunit, cjava]
  },
  {
    id: 3,
    name: "Power BI & Analytics",
    title: "Business Intelligence & Visualization",
    description: "Master data visualization and analytics using Power BI with integrations to Snowflake, Azure SQL, and Google Analytics 4 to turn raw data into actionable insights.",
    topics: [
      "Power BI Fundamentals",
      "Dashboards & Reports",
      "Data Integration (Azure SQL, Snowflake)",
      "Google Analytics 4",
      "FB Meta Data Analytics"
    ],
    image:dsbusiness,
    tools: [cgithub, cintelli]
  },
  {
    id: 4,
    name: "ML & Python",
    title: "Python Programming for Data Science",
    description: "Use Python for data wrangling, visualization, and statistical analysis. Learn libraries such as NumPy, Pandas, Seaborn, and Matplotlib along with core statistics for data science.",
    topics: [
      "Python Basics",
      "NumPy & Pandas",
      "Seaborn & Matplotlib",
      "Statistics - Sampling, Scaling, Distribution",
      "Hypothesis Testing"
    ],
    image:dspython,
    tools: [cgithub, cjava]
  },
  {
    id: 5,
    name: "Power Platform",
    title: "Introduction to Power Platform",
    description: "Understand and implement essential ML algorithms including supervised, unsupervised, and ensemble techniques for predictive modeling and classification.",
    topics: [
      "Power Apps",
      "Power Automate"
    ],
    image:dsmicrosoft,
    tools: [cintelli, cgithub]
  },
  {
    id: 6,
    name: "Generative AI & LLMs",
    title: "Advanced AI with LLMs and Generative Tools",
    description: "Dive deep into generative AI technologies such as GPT-4 and Gemini. Learn to build and fine-tune LLMs, understand autoencoders, and deploy AI models to the cloud.",
    topics: [
      "Generative AI - GPT-4, Gemini, Tabnine, Perplexity",
      "Autoencoders & Regression Models",
      "NLP Basics for LLMs",
      "Deploying Models (AWS, Azure)",
      "Ethical AI Considerations"
    ],
    image:dsai,
    tools: [cgithub]
  },
  {
    id: 7,
    name: "Capstone Project",
    title: "Capstone & Real-World Projects",
    description: "Complete an industry-grade capstone project under expert mentorship. Use tools like JIRA and TFS for project management and prepare for data science job interviews.",
    topics: [
      "Capstone Project Planning",
      "Project Collaboration (JIRA, TFS)",
      "Teamwork in Data Science",
      "Interview Preparation",
      "Presentation & Documentation"
    ],
    image:dscapstone,
    tools: [cintelli, cgithub]
  }
];

  const [activeCourse, setActiveCourse] = useState(1);

  const handleCourseClick = (courseId) => {
    setActiveCourse(courseId);
  };

  const currentCourse = courseData.find(course => course.id === activeCourse);

  return (
    <div>

      <div className="hero-wrapper">
        <div className="container-course-page">
          <div className="tagline">Design & Shape the Future of Coding with AI Code Assistant!</div>
          <h1 className="title">Advanced Job-Ready Data Science with AI Integration</h1>
          <p className="subtitle">
            Transform your Tech Career with Industry-Aligned, In-Demand Skills and AI-Powered Code Assistance
          </p>
          <div className="button-wrapper">
            <button className="apply-button">Apply Now</button>
            <button className="download-button" onClick={handleScrollToCurriculum}>Download Syllabus</button>
          </div>
          <div className="content-wrapper">

            <img src={sjrleftgirl} alt="Person 1" className="image-wrapper" />

            <div className="text-wrapper">
  <div className="feature">
    {/* <LuSendHorizontal className="course-1-icons" /> */}
    <p className="feature-text">
      <b>Master In-Demand AI & Data Skills:</b> Build expertise in Excel, SQL, Python, Power BI, Machine Learning, Generative AI (GPT-4, Gemini), and cloud deployment using AWS/Azure.
    </p>
  </div>
  <div className="feature">
    {/* <LuSendHorizontal className="course-1-icons" /> */}
    <p className="feature-text">
      <b>Learn from Industry Professionals:</b> Get mentorship from experienced Data Scientists through live sessions, pre-recorded mentor content, and real-world project guidance.
    </p>
  </div>
  <div className="feature">
    {/* <LuSendHorizontal className="course-1-icons" /> */}
    <p className="feature-text">
      <b>Work on Real Projects & Get Hired:</b> Build AI models with a data science team, complete capstone projects, and prepare for interviews with top-tier companies.
    </p>
  </div>
</div>


            <img src={jrrightgirl} alt="Person 2" className="image-wrapper" />

          </div>
        </div>

      </div>

      <div className="stats">
        {statsData.map((stat, index) => (
          <div className="stat" key={index}>
            <h2 className="stat-number">{counts[index]}+</h2>
            <p className="stat-text">{stat.text}</p>
          </div>
        ))}
      </div>

      <div ref={curriculumRef}>
  <div className="curriculum-container">
    <p className="curriculum-header">Data Science Career Acceleration Program</p>
    <h1 className="curriculum-title">AI-Enhanced Data Science Advanced Curriculum</h1>
    
    <div className="curriculum-courses-navigation">
      {courseData.map(course => (
        <button 
          key={course.id}
          className={`curriculum-course-button ${activeCourse === course.id ? 'active' : ''}`}
          onClick={() => handleCourseClick(course.id)}
        >
          Module {course.id}<br/>{course.name}
        </button>
      ))}
    </div>
    
    <div className="curriculum-course-details">
      <h2 className="curriculum-course-title">{currentCourse.title}</h2>
      <p className="curriculum-course-description">{currentCourse.description}</p>

      <div className='curriculumtopics-pic'>
        <div className="curriculum-topics-covered">
          <h3>Topics Covered</h3>
          <ul className="curriculum-topics-list">
            {currentCourse.topics.map((topic, index) => (
              <li key={index} className="curriculum-topic-item">
                <FaCheckCircle className="curriculum-icon" />
                <span>{topic}</span>
              </li>
            ))}
          </ul>
        {/* <a className="curriculum-read-more">Read More</a> */}
      </div>

      <div className="curriculum-course-image-container">
        <img src={currentCourse.image} alt={currentCourse.name} className="curriculum-course-image"/>
      </div>
      </div>
     

      {/* If you want to show the tools visually */}
      {/* <div className="curriculum-tools-section">
        {currentCourse.tools.map((tool, index) => (
          <img key={index} src={tool} alt={`Tool ${index + 1}`} />
        ))}
      </div> */}
    </div>

    <div className="curriculum-downloadsyllabus-section">
      <button className="curriculum-download-syllabus-button">Download Syllabus</button>
    </div>
  </div>
</div>


          <div className="journey-container">
            <h2>Learning Journey at Hruthi Ai</h2>
            <div className="journey-steps">
              {steps.map((step, index) => (
                <div key={index} className="journey-step">
                  <div className="journey-icon">
                    <img src={step.img} alt={step.title} />
                  </div>
                  {index < steps.length - 1 && <FaArrowRight className="arrow-icon" />}
                </div>
              ))}
            </div>
            <div className="journey-details">
              {steps.map((step, index) => (
                <div key={index} className="journey-card">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              ))}
            </div>
          </div>

      <>
      <div className="Handonexperience-container">
          <header className="Handonexperience-header">
            <h3 className="Handonexperience-subheading">
              Build your skills through real-world projects
            </h3>
            <h1 className="Handonexperience-heading">
              Gain Hands-on Experience that Sets You Apart
            </h1>
          </header>

          <section className="Handonexperience-offerings">
            <Card
              image={dafoundational}
              title="Foundational Project"
              description="A Wikipedia clone project replicates a platform for creating, editing, and viewing articles with search functionality. It demonstrates skills in content management, real-time updates, and user collaboration."
            />
            <Card
              image={daintermediate}
              title="Intermediate Project"
              description="A Namma Yatri clone project replicates an auto-booking app with real-time location tracking, fare estimates, and driver-user interactions. It demonstrates expertise in geolocation services, user authentication, and backend integration."
            />
            <Card
              image={daadvanced}
              title="Advanced Project"
              description="A Blinkit clone project replicates a grocery delivery platform with real-time order tracking, product listing, and user authentication. It showcases full-stack development, real-time updates, and efficient UI/UX design."
            />
          </section>
          <section className="Handonexperience-offerings">
            <Card
              image={dah1foundational}
              title="Foundational Project"
              description="A foundational login form project helps learners understand form handling, input validation, and basic user authentication. It builds essential frontend skills and introduces core security concepts."
            />
            <Card
              image={dah1intermediate}
              title="Intermediate Project"
              description="A Porter clone project replicates a logistics platform for booking mini-trucks and transporting goods with real-time tracking and fare estimation. It demonstrates expertise in location services, booking systems, and backend integration."
            />
            <Card
              image={dah1advanced}
              title="Advanced Project"
              description="A Zomato clone project replicates a restaurant discovery and food ordering platform with features like search, reviews, and real-time order tracking. It showcases full-stack development, API integration, and scalable UI/UX design."
            />
          </section>
        </div>
      </>

      <div className="gr-ds-data-science">
      <h4>Why Data Science Program?</h4>
      <h1>
        <span>Rising Demand</span> for Data Science, AI Skills and Career Growth
      </h1>
      {/* <div className="gr-ds-tabs">
        {["Data Analyst", "Data Scientist"].map((tab) => (
          <span
            key={tab}
            className={activeTabing === tab ? "gr-ds-selected-tab" : "gr-ds-inactive-tab"}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </span>
        ))}
      </div> */}
      <div className="gr-ds-container">
        <div className="gr-ds-graph">
          {showGraphs && <CanvasJSChart options={options} />}
        </div>
        <div className="gr-ds-companies">
          <h3>Top Companies Hiring</h3>
          <div className="gr-ds-company-list">
            {companyImages.map((image, index) => (
              <img key={index} src={image} alt={`company-${index}`} className="gr-ds-company-image" style={{ "--delay": index }} />
            ))}
          </div>
        </div>
        <div className="gr-ds-demand">
          
          <div className="gr-ds-demand-card">
          <h3>Demand</h3>
            <FaBriefcase className="gr-ds-icon" />
            <p>40% Growth in Data Scientist Job Roles by 2028</p>
          </div>
        </div>
      </div>
    </div>

      <div className="hirrecompanyfull">

        <div className="hire-company-container">
          <div className='hire-company-part-a'>
            <div className='hire-company-sub-part'>
              <FaUsersLine className='hire-course-icon' />
              <p1 className='hire-course-icon-tag'>750 HIRING PARTNERS</p1>
            </div>
            <div className="hire-company-logos">
              {companyLogos.map((logo, index) => (
                <img
                  key={index}
                  src={logo}
                  alt={`Logo ${index + 1}`}
                  className="hire-logo-course"
                />
              ))}
            </div>
          </div>
          <div className="trusted-section">
            <img className="trusted-img" src={trusted} alt="Trusted" />
          </div>
        </div>
      </div>

      <div className='cp-mentors'>
        <div className='cp-mentor-title'>
          <p1>ALUMINI</p1>
          <p2>working at companies bigger brands and are extremely important to us and we are grateful for the opportunity to have placed them on such impressive teams around the country.</p2>
        </div>
        <div className='cp-mentor-components'>
          <div className="carousel-container">
            <div className="cp-mentor-components carousel-track">
              {/* Duplicating list for infinite scrolling effect */}
              {[...mentors, ...mentors].map((mentor, index) => (
                <div className="cp-mentor-1" key={index}>
                  <img src={mentor.image} alt={mentor.name} className="cp-mentor-image" />
                  <div className="cp-mentor-1-data">
                    <p1>{mentor.name}</p1>
                    <p2>{mentor.role}</p2>
                    <div className="cp-mentor-company-image-div">
                      <img src={mentor.company} alt="Company" className="cp-mentor-company-image" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="cr-certification-container">
<h2>Industry Recognized Certification Course</h2>


<div className="cr-certification-content">
  <div className="cr-certification-text">
  <div className="cr-certification-tabs">
  {Object.keys(certifications).map((tab) => (
    <span
      key={tab}
      className={activeTab === tab ? 'active' : ''}
      onClick={() => setActiveTab(tab)}
    >
      {tab}
    </span>
  ))}
</div>
    <h3>{certifications[activeTab].title}</h3>
    <ul>
      {certifications[activeTab].points.map((point, index) => (
        <li key={index}>&#10004; {point}</li>
      ))}
    </ul>
  </div>
  <div className="cr-certification-image">
    <img src={certifications[activeTab].img} alt={activeTab} />
  </div>
</div>
</div>

      <div className="bootcamp-container">
        <header className="bootcamp-header">
          <h3 className="bootcamp-subheading">
          Tools We Use and Learn
          </h3>
        </header>

         <section className="bootcamp-offerings">
          <Cards
            image={dsjupyter}
            title="Jupyter"
            description="Jupyter Notebook is an open-source web application that allows you to create and share documents containing live code, equations, visualizations, and narrative text. It supports multiple programming languages, making it ideal for data cleaning, transformation, and machine learning tasks."
          />
          <Cards
            image={dsnumpy}
            title="Numpy"
            description="NumPy is a powerful Python library used for numerical computing and handling large multi-dimensional arrays and matrices. It provides a wide range of mathematical functions to perform operations efficiently on these arrays. NumPy is fundamental for scientific computing and serves as the base for many other data science and machine learning libraries."
          />
          <Cards
            image={dspanda}
            title="Pandas"
            description="Pandas is a powerful open-source Python library used for data manipulation and analysis. It provides data structures like DataFrames and Series that make handling structured data easy and efficient. Pandas is widely used for cleaning, transforming, and analyzing large datasets in data science and machine learning projects."
          />
          <Cards
            image={dsazure}
            title="Azure Machine Learning"
            description="Azure Machine Learning is a cloud-based service by Microsoft that enables data scientists and developers to build, train, and deploy machine learning models at scale. It provides an end-to-end platform with tools for data preparation, model experimentation, and automated machine learning."
          />
          <Cards
            image={dsmatplotlib}
            title="Matplolib"
            description="Matplotlib is a widely used Python library for creating static, animated, and interactive visualizations. It provides extensive plotting capabilities, from simple line charts to complex 3D graphs. It is highly customizable and integrates well with other data science libraries like NumPy and Pandas."
          />
          <Cards
            image={dsseaborn}
            title="Seaborn"
            description="Seaborn is a Python data visualization library built on top of Matplotlib that provides a high-level interface for drawing attractive and informative statistical graphics. It simplifies complex visualizations like heatmaps, time series, and violin plots with less code. Seaborn is widely used for exploratory data analysis and creating visually appealing charts easily."
          />
        
        </section>
      </div>

      <div className='cp-pricing-container'>
        <p className='cp-pricing-title'>Simple, Transparent Pricing</p>
        <div className='cp-pricing-box'>
          <div className='cp-price-left'>
            <h3>What's Included in the Price</h3>
            <p>Features/Benefits</p>
            <ul>
              <li>Get Advanced Certificate Programme from Hruthi AI Tech Hub without quitting your job.</li>
              <li>Practical Learning with Industry Projects and Case Studies</li>
              <li>Rigorous Cutting Edge Curriculum developed in Collaboration with Teaching experts and Industry leaders in Datascience.</li>
              <li>Dedicated Student support team from Hruthi AI Tech Hub</li>
              <li>Networking opportunities with our alumni & leading industry experts</li>
            </ul>
          </div>
          <div className='cp-price-right'>
            <h2>Empowering learners of tomorrow</h2>
            <p>Over 2,300 students have completed this course and started working at their dream job, whats stopping you?</p>
          </div>
        </div>
      </div>

      <div className='cp-booking-container'>
        <div className='cp-booking-session'>
          <h1>Book live demo class now!</h1>
          <h3>Register now for our FREE live demo class on Data Science.</h3>
          <button className='cp-booking-button'>Register Now</button>
        </div>
      </div>

      <div className="faq-container">
        <h3 className="faq-title">FAQ</h3>
        <h1 className="faq-heading">Frequently Asked Questions</h1>
        <div className="faq-content">
          {/* Left Tabs */}
          <div className="faq-tabs">
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`Course14-tab ${activeTabs === index ? "active" : ""}`}
                onClick={() => toggleTab(index)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Right FAQ Section */}
          <div className="faq-details">
            <h2 className="faq-question">{faqs[activeTabs].question}</h2>
            {faqs[activeTabs].answer && (
              <p className="faq-answer">{faqs[activeTabs].answer}</p>
            )}
            <ul className="faq-list">
              {faqs.map((faq, index) =>
                activeTabs !== index ? (
                  <li key={index} className="faq-list-item">
                    {faq.question} <span className="faq-toggle">+</span>
                  </li>
                ) : (
                  <li key={index} className="faq-list-item active">
                    {faq.question} <span className="faq-toggle">×</span>
                  </li>
                )
              )}
            </ul>
            <button className="view-more-btn">View More</button>
          </div>
        </div>
      </div>

    </div>
  )
}

export default DataScience
